import { o } from 'odata';

import { odataConf } from '../odata/conf';

const url = `${process.env.VUE_APP_APIURL}/odata/`;

export default {
  loadMetricsWithMetricTabs: async ({ commit, rootState }) => {
    const data = await o(url, odataConf.getConf(rootState))
      .get('metrics')
      .query({ $filter: 'IsDeleted eq false', $expand: 'metricTab' });
    commit('metricsWithMetricTabs', data);
  },
};
